(() => {
  // src/details.ts
  (() => {
    document.addEventListener("click", (e) => {
      const tab = e.target.closest(".details__tab");
      if (!tab) return;
      const section = tab.closest(".details--tabbed");
      if (!section) return;
      if (tab.classList.contains("details__tab--active")) return;
      const tabs = Array.from(section.querySelectorAll(".details__tab"));
      const panels = Array.from(section.querySelectorAll('.details__row[role="tabpanel"]'));
      const i = tabs.indexOf(tab);
      const activeTab = section.querySelector(".details__tab--active");
      const currentIndex = activeTab ? tabs.indexOf(activeTab) : -1;
      const direction = i > currentIndex ? "right" : "left";
      tabs.forEach((t) => {
        t.classList.remove("details__tab--active");
        t.setAttribute("aria-selected", "false");
      });
      panels.forEach((p) => {
        p.hidden = true;
      });
      tab.classList.add("details__tab--active");
      tab.setAttribute("aria-selected", "true");
      section.style.setProperty("--details-active-index", String(i));
      const panel = panels[i];
      if (panel) {
        panel.hidden = false;
        panel.classList.remove("details__row--slide-from-right", "details__row--slide-from-left");
        void panel.offsetWidth;
        panel.classList.add(`details__row--slide-from-${direction}`);
      }
    });
    const sectionObservers = /* @__PURE__ */ new Map();
    const initScrollReveal = (scope) => {
      var _a, _b;
      const root = scope || document;
      const observer = (_b = (_a = window.HotelCollection).initScrollReveal) == null ? void 0 : _b.call(
        _a,
        root.querySelectorAll(".details--side-by-side .details__row"),
        "details__row--will-reveal",
        "details__row--revealed"
      );
      if (observer && (scope == null ? void 0 : scope.id)) sectionObservers.set(scope.id, observer);
    };
    document.addEventListener("DOMContentLoaded", () => initScrollReveal());
    document.addEventListener("shopify:section:load", (e) => initScrollReveal(e.target));
    document.addEventListener("shopify:section:unload", (e) => {
      var _a;
      (_a = sectionObservers.get(e.target.id)) == null ? void 0 : _a.disconnect();
      sectionObservers.delete(e.target.id);
    });
  })();
})();
